const AppListIcon = ({classCustom}) => {
    return (
        <svg
            className={classCustom ? classCustom : "h-6 w-6"}
            viewBox="0 0 22 22"
            strokeWidth="2"
            stroke="currentColor" 
        >
            <g id="SVGRepo_bgCarrier" strokeWidth={0} />
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
            <g id="SVGRepo_iconCarrier">
                {" "}
                {/* Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools */}{" "}
                <title>ic_fluent_app_store_24_filled</title>{" "}
                <desc>Created with Sketch.</desc>{" "}
                <g
                    id="🔍-Product-Icons"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                >
                    {" "}
                    <g id="ic_fluent_app_store_24_filled" stroke="currentColor" fillRule="nonzero">
                        {" "}
                        <path
                            d="M17.75,3 C19.5449254,3 21,4.45507456 21,6.25 L21,17.75 C21,19.5449254 19.5449254,21 17.75,21 L6.25,21 C4.45507456,21 3,19.5449254 3,17.75 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L17.75,3 Z M9.36866957,15.2541207 L7.63066957,15.2541207 L7.56419595,15.3696993 L7.5187736,15.4610282 C7.37700209,15.8021724 7.50562161,16.2040885 7.83345734,16.395642 C8.16132045,16.587148 8.57459569,16.5018069 8.80214266,16.2107727 L8.85939238,16.1263533 L9.36866957,15.2541207 Z M13.2925743,10.0240744 L12.4215743,11.5160744 L15.079611,16.1237835 L15.1363996,16.2085136 C15.3623565,16.5007826 15.7751611,16.5883646 16.1040459,16.3986183 C16.4329304,16.2088714 16.5637317,15.8076616 16.4238081,15.4657566 L16.3788804,15.3741835 L15.8765743,14.5040744 L16.7518937,14.504946 L16.8536642,14.4980994 C17.1864602,14.4529518 17.4498994,14.1895126 17.495047,13.8567166 L17.5018937,13.754946 L17.495047,13.6531755 C17.4498994,13.3203795 17.1864602,13.0569403 16.8536642,13.0117927 L16.7518937,13.004946 L15.0115743,13.0040744 L13.2925743,10.0240744 Z M13.2631232,7.10145556 C12.9352692,6.90993382 12.5219947,6.99527355 12.2944542,7.28631143 L12.2372064,7.37073189 L11.9965416,7.7799285 L11.7634041,7.37425403 L11.7066156,7.28952396 C11.5032545,7.02648174 11.1485467,6.9292361 10.8398818,7.05074264 L10.7389696,7.09941939 L10.6542395,7.15620792 C10.3911973,7.35956896 10.2939517,7.71427678 10.4154582,8.02294165 L10.464135,8.12385388 L11.1265416,9.2709285 L8.94557613,13.0049285 L7.25157613,13.004946 L7.14980557,13.0117927 C6.78373001,13.0614551 6.50157613,13.3752503 6.50157613,13.754946 C6.50157613,14.1346418 6.78373001,14.448437 7.14980557,14.4980994 L7.25157613,14.504946 L13.279,14.504803 L12.414,13.004803 L10.6825761,13.0039285 L13.5323945,8.12738105 L13.5778169,8.03605217 C13.7195883,7.69490804 13.590968,7.29299325 13.2631232,7.10145556 Z"
                            id="🎨-Color"
                        >
                            {" "}
                        </path>{" "}
                    </g>{" "}
                </g>{" "}
            </g>
        </svg>


    )
}
export default AppListIcon